

export function description_room1($lang = 'ru'){
       
	switch ($lang) {
		case 'ru':
			return('Апартамент для 2-4 человек, 1 этаж, спальня, гостинная с диваном-кроватью, панорамное остекление, WiFi, полностью оборудованная кухня, зона барбекю, просторная лodжия, туалет с душем, парковка, прачечная');

		case 'en':
			return('Apartment for 2-4 people, ground floor, bedroom, dining room with sofa, panoramic windows, WiFi, fully equipped kitchen, barbecue spot, big loggia, bathroom (with shower), parking, laundry');

		
		case 'sr':
			return('Апартман за 2-4 особе, 1 спрат, спаваћа соба, дневна соба са каучем на развлачење, панорамско застакљивање, WiFi, потпуно опремљена кухиња, простор за роштиљ, пространа лођа, тоалет са тушем, паркиралиште, веш');

		case 'de':
			return('Wohnung für 2-4 Personen, Erdgeschoss, Schlafzimmer, Wohnzimmer mit Schlafsofa, Panoramaverglasung, WiFi, voll ausgestattete Küche, Grillplatz, geräumige Loggia, Toilette mit Dusche, Parken, Waschraum');

		default:
			return('Апартамент для 2-4 человек, 1 этаж, спальня, гостинная с диваном-кроватью, панорамное остекление, WiFi, полностью оборудованная кухня, зона барбекю, просторная лdжия, туалет с душем, парковка, прачечная');

	}

		
}

export function description_room2($lang = 'ru'){
	

	switch ($lang) {
		case 'ru':
			return('Апартамент для 2-6 человек, этаж 2, 3 спальни, WiFi, панорамное остекление, полностью оборудованная кухня в зоне барбекю, зона барбекю, просторная лоджия, два санузла с душем, парковка');


		case 'en':
			return('Apartment for 2-6 people, floor 1, 3 bedrooms, WiFi, panoramic windows, fully equipped kitchen in a separate building in the garden, barbecue spot, big loggia, 2 WC with shower, parking');

		
		case 'sr':
			return('Апартман за 2-6 особе, спрат 2, 3 спаваће собе, WiFi, панорамско застакљивање, потпуно опремљена кухиња у простору за роштиљ, простор за роштиљ, пространа лођа, два купатила са тушем, паркиралиште');

		case 'de':
			return('Wohnung für 2-6 Personen, Erste Geschoss, 3 Schlafzimmer, WiFi, Panoramaverglasung, voll ausgestattete Küche im Grillbereich im Garten, Grillplatz, großzügige Loggia, Zwei Badezimmer mit Dusche, Parken');

		default:
			return('Апартамент для 2-6 человек, этаж 2, 3 спальни, WiFi, панорамное остекление, полностью оборудованная кухня в зоне барбекю, зона барбекю, просторная лodжия, два санузла с душем, парковка');


	}

		
}

export function description_room3($lang = 'ru'){
	

	switch ($lang) {
		case 'ru':
			return('Апартамент-студия для 2-3 человек, 3 этаж, панорамный обзор, WiFi, полностью оборудованная кухня, зона барбекю, парковка, балкон, туалет с душем, прачечная');


		case 'en':
			return('Apartment-studio for 2-3 people, floor 2, panoramic window, WiFi, full equipped kitchen, place for barbecue, balcony, WC with shower, laundry, parking');

		
		case 'sr':
			return('Студио апартман за 2-3 особе, спрат 3, панорамски поглед, WiFi, потпуно опремљена кухиња, простор за роштиљ, балкон, тоалет са тушем, веш, паркиралиште');

		case 'de':
			return('Studio-Apartment für 2-3 Personen, 2. Geschoss, Panoramablick, WiFi, voll ausgestattete Küche, Grillplatz, Balkon, Toilette mit Dusche, Waschraum, Parken');

		default:
			return('Апартамент-студия для 2-3 человек, 3 этаж, панорамный обзор, WiFi, полностью оборудованная кухня, зона барбекю, парковка, балкон, туалет с душем, прачечная');


	}

		
}

export function description_complex($lang = 'ru'){
	
	switch ($lang) {
		case 'ru':
			return('Вы можете бронировать весь объект или два этажа для семьи или  большой компании. Цена обсуждается в зависимости от сезона и продолжительности бронирования');

		case 'en':
			return('You can book the entire property or two floors for a family or a large group. The price is discussed depending on the season and duration of the booking');

		case 'sr':
			return('Можете резервисати цело имање или два спрата за породицу или већу групу. Цена се расправља у зависности од сезоне и трајања резервације');

		case 'de':
			return('Sie können das gesamte Anwesen oder zwei Etagen für eine Familie oder eine große Gruppe buchen. Der Preis wird je nach Saison und Dauer der Buchung besprochen');

		default:
			return('Вы можете бронировать весь объект или два этажа для семьи или  большой компании. Цена обсуждается в зависимости от сезона и продолжительности бронирования');


	}
}